<template>
    <BaseNav :nav="$store.getters.getNavData"></BaseNav>
    <Kv :kvData="$store.getters.getKvData"></Kv>
    <router-view />
    <Footer></Footer>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import Kv from "@/components/Kv";
import Footer from "@/components/Footer";

export default {
    name: "CSR",
    components: {
        BaseNav,
        Kv,
        Footer,
    },
};
</script>
<style lang="sass" scoped></style>
